import React, { useRef, useEffect } from "react";
import experience from "../constants/experience";

const Card = (props) => {
	const { work } = props;
	const ref = useRef(null);
	useEffect(() => {
		const { current } = ref;
		const expCardContentHeight = current.querySelector(".experience-card_content").offsetHeight;
		const expCardHoverContentHeight = current.querySelector(".experience-card_hover").offsetHeight;

		const desireHeight = Math.max(expCardHoverContentHeight, expCardContentHeight)
		// const experienceCard = current.querySelector(".experience-card");
		current.style.height = `${desireHeight}px`;
	}, [])

	return (
		<div ref={ref} className="experience-card">
			<div className="experience-card_hover">
				<picture>
					<source srcSet={require(`../img/${work.bgsmall}`)} media="(max-width: 768px)" />
					<source srcSet={require(`../img/${work.bglarge}`)} media="(min-width: 768px)" />
					<source srcSet={require(`../img/${work.bglarge}`)} media="(min-width: 1920px)" />
					<img alt="img" src={require(`../img/${work.bgsmall}`)} />
				</picture>
				<section class="hover-content_wrapper"><span>{work.technology}</span></section>
			</div>
			<div className="experience-card_content">
				<label className="company">{work.company}</label>
				<h3 className="title">{work.title}</h3>
				<span className="duration">{work.duration}</span>
				<p className="desc">{work.desc}</p>
				<p className="role">{work.role}</p>
			</div>

		</div>
	);
};

const Work = () => {
	const { data } = experience;
	return (
		<div id="work" className="work-container">
			<div className="work-container_card-section">
				{data.map((work) => (
					<Card work={work} />
				))}
			</div>
		</div>
	);
};

export default Work;
